import { useServices } from '../../../services/useServices';
import { usePipelineQuery } from './usePipelineQuery';

export const useFunctionPipeline = (pipelineId: string, history = 50) => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'function', pipelineId, history],
    () => pipelines.getFunctionPipeline(pipelineId, history)
  );
};
